import Text from '@atoms/Text/Text';
import SiteEnum from '@models/enums/SiteEnum';
import classNames from 'classnames';

export interface ITextBlock {
  readonly content: string;
  readonly isArticlePage?: boolean;
  readonly site: SiteEnum;
  readonly title?: string;
}

const TextBlock = ({ content, title, isArticlePage }: ITextBlock) => {
  return (
    <section
      className={classNames(
        isArticlePage
          ? 'tw-mx-auto tw-my-16 tw-max-w-[705px] tw-px-4 tw-text-lg xl:tw-my-20'
          : 'tw-container',
        'tw-text-grey-100'
      )}
    >
      {title && (
        <Text as="h2" variant="ds-headline-2" className="tw-mb-4 md:tw-mb-6">
          {title}
        </Text>
      )}
      <div
        className={classNames(
          isArticlePage
            ? 'tw-rich-text--article tw-group/article'
            : 'tw-rich-text'
        )}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </section>
  );
};

export default TextBlock;
